<template>
  <v-app-bar app color="white" light>
    <v-app-bar-nav-icon @click="$emit('toggleDrawer')" :class="showToggle ? '' : 'd-flex d-sm-flex d-md-none'"></v-app-bar-nav-icon>
    <router-link to="/" class="d-flex align-center">
      <v-img
        alt="ASCA Logo"
        class="shrink mr-3"
        contain
        src="../../assets/logo.svg"
        transition="scale-transition"
        width="40"
      />

      <v-img
        alt="ASCA Name"
        class="shrink mt-1 hidden-sm-and-down"
        contain
        min-width="150"
        src="../../assets/asca-name.svg"
        width="100"
      />
    </router-link>
    <v-spacer></v-spacer>
    <v-chip
      v-if="environmentLabel"
      :aria-label="`${environmentLabel} environment`"
      class="environment-indicator"
      color="orange"
      label
      small
      text-color="black"
    >
      {{ environmentLabel }}<span class="hidden-xs-only">&nbsp;ENVIRONMENT</span>
    </v-chip>
    <v-spacer></v-spacer>
    <router-link
      to="/aussietimes"
      class="mr-5 hidden-sm-and-down"
      target="_blank"
    >
      <font-awesome-icon :icon="['fa', 'newspaper']" class="social-icons" />
    </router-link>
    <a
      href="https://www.facebook.com/asca1957/"
      class="mr-5 hidden-sm-and-down"
      target="_blank"
    >
      <font-awesome-icon
        :icon="['fab', 'facebook-square']"
        class="social-icons"
      />
    </a>
    <a
      href="https://www.youtube.com/channel/UC490D1qEJtV7oiDp6KOHEvA"
      class="mr-5 hidden-sm-and-down"
      target="_blank"
    >
      <font-awesome-icon :icon="['fab', 'youtube']" class="social-icons" />
    </a>
    <div>
      <div class="profile-name-circle">
        <span v-if="!!userInfo">{{ initials }}</span>
      </div>
    </div>
    <v-menu offset-y bottom>
      <template v-slot:activator="{ on, attrs }">
        <font-awesome-icon v-bind="attrs" v-on="on" icon="chevron-down" />
      </template>
      <v-list class="profile-dropdown">
        <v-list-item>
          <v-list-item-title>
            <p v-if="!!userInfo">
              {{ userInfo.username }}<br />({{ userInfo.firstName }}
              {{ userInfo.lastName }})
            </p>
          </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-for="(item, index) in items" :key="index">
          <v-list-item-title>
            <router-link :to="item.route"> {{ item.title }}</router-link>
          </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-on:click="signUserOut()">
          <v-list-item-title> Sign Out </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script lang="ts">
import Vue from "vue";
import axios from "axios";
import * as Sentry from "@sentry/vue";
import { UserInfo } from "@/types/User";
import { env } from "@/environment/environment";

export default Vue.extend({
  name: "AppNavbar",
  data() {
    return {
      items: [],
    };
  },
  props: {
    showToggle: Boolean
  },
  methods: {
    signUserOut: function () {
      axios.defaults.headers.common["Authorization"] = null;
      localStorage.removeItem("userToken");
      this.$store.commit("loadUserInfo", null);
      Sentry.setUser(null);
      Sentry.setTag("user.role", "anonymous");
      Sentry.setTag("membership.active", "false");
      this.$navigate("/logout");
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    initials(): string {
      if (!this.userInfo) return "";

      return `${this.userInfo.firstName?.[0] ?? ""}${this.userInfo.lastName?.[0] ?? ""}`.toUpperCase();
    },
    environmentLabel(): string {
      const labels: Record<string, string> = {
        local: "LOCAL",
        dev: "DEVELOPMENT",
        stg: "STAGING",
      };

      return labels[String(env.VUE_APP_ENVIRONMENT).toLowerCase()] || "";
    },
  },
});
</script>

<style scoped>
.environment-indicator {
  font-weight: 700;
  letter-spacing: 0.06em;
}
</style>
